const decodeURIComponentSafe = (s: string) => {
  if (!s) {
    return s;
  }
  return decodeURIComponent(s.replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25'));
};

const sanitize = (s?: string) => (s !== undefined && s !== null ? decodeURIComponentSafe(s) : '');

export default sanitize;
